import { Observable } from 'rxjs';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import { ImageUploaderOptions } from '@monjin/vue-toolkit/ImageUploader/ImageUploader';

import { FileUploadState, uploadFiles } from '@monjin/data/service/upload';
import WithTemplate from './UploadLogo.html';

// Default allowed size is 8MB
const DEFULT_ALLOWED_FILE_SIZE_BYTES: number = 8000000;

const DEFAULT_OPTIONS: ImageUploaderOptions = {
    showDropZone: true,
    allowedFileSize: DEFULT_ALLOWED_FILE_SIZE_BYTES,
    allowMultipleImages: false,
    allowedFileTypes: ['image/jpg', 'image/jpeg', 'image/png'],
    maxFilesLimit: 1, // This matters in case of multiple files.
    uploaderStyleClass: 'IUC__drop-zone',
    showDefaultGallery: true,
    hideButtonAfterUpload: true,
    gridCellHeight: 300,
    gridCellWidth: 500,
    uploadedImages: [],
    uploadDropZoneText: 'Upload logo'
};

@WithTemplate
@Component({})
export default class UploadLogo extends Vue {

    @Prop()
    public resourceBaseUrl: string;

    public logoUrl: string = '';

    public imageUploaderOptions: ImageUploaderOptions = DEFAULT_OPTIONS;

    public uploadImageUrl: string = '';

    public imageUploading: boolean = false;

    public onImageUpload(validImages) {
        if (validImages.length === 1) {
            this.imageUploading = true;
            this.uploadImageUrl = URL.createObjectURL(validImages[0]);

            const url: string = `${this.resourceBaseUrl}upload/1`;

            const uploadObs: Observable<FileUploadState> = uploadFiles(url, validImages, 'orglogo');

            // TODO: Handle error conditions
            uploadObs.subscribe((data: FileUploadState) => {
                if (data.files) {
                    this.imageUploading = false;

                    const tenantLogoUrls = {
                        logoMediumUrl: data.files[0].fn
                    };

                    this.logoUrl = tenantLogoUrls.logoMediumUrl;
                }
            });
        } else {
            this.logoUrl = '';
        }
    }

    public onNext() {
        this.$emit('next', 7, this.logoUrl);
    }
}
